





import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'PopupBackground',
})
export default class PopupBackground extends Vue {
  @Prop({required: false, type: String, default: null}) readonly onCloseRedirectTo: string | undefined

  escapePopup() {
    if (this.onCloseRedirectTo) {
      this.$router.push(this.onCloseRedirectTo)
    } else {
      this.$router.push('/');
    }
  }
}
